import React, { useEffect, useState } from "react";
import { PieChart } from "react-minimal-pie-chart";
import share_icon from "../../../assets/images/share_icon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { usePreview } from "../../../context/PreviewContextProvider";

// MintCard component for displaying NFT information and actions
const MintCard = ({
  card, // NFT card data
  btn, // Button label
  show, // Toggle for visibility of certain elements
  download, // Toggle for download button visibility
  overlay, // Toggle for overlay on image
  overlayText, // Toggle for overlay text visibility
  newest, // Toggle for "Newest" ribbon display
  onBtnOpen, // Handler for button click
  onPieOpen, // Handler for pie chart click
  onDownload, // Handler for download action
  onShare, // Handler for share action
  isOwner, // Check if the current user is the owner
  delete_icon, // Toggle for delete icon visibility
  onDelete, // Handler for delete action
}) => {
  // Custom context for accessing campaign data and style data
  const {
    campaign,
    data
  } = usePreview();

  const [address, setAddress] = useState("");

  // Class name and style for image overlay and buttons based on props
  const imgClass = overlay ? "card__img img-overlay" : "card__img";
  const download_btn_style = download
    ? { visibility: "visible" }
    : { visibility: "hidden" };
  const delete_btn_style = delete_icon
    ? { visibility: "visible" }
    : { visibility: "hidden" };

  // Effect to format the NFT owner's address as a truncated string
  useEffect(() => {
    const checkAddress = async () => {
      if (card.address) {
        const trunc_address = ` ${card.address.slice(
          0,
          6
        )}...${card.address.slice(card.address.length - 4)} `;
        setAddress(trunc_address);
      }
    };
    checkAddress();
  }, [card.address]);

  // Function to display action button if available, or a label if the user is the owner
  const showButton = () => {
    if (btn) {
      return (
        <div>
          <button
            className="card__btn"
            style={{
              color: data.web_main_color,
              borderColor: data.web_main_color,
            }}
            onClick={() => onBtnOpen(card, btn)}
          >
            {btn}
          </button>
        </div>
      );
    } else {
      if (isOwner) {
        return (
          <div className="card__text card__addr tooltip">constant.MY_NFT</div>
        );
      }
    }
  };

  // Function to conditionally render overlay text
  const showOverlayText = () => {
    if (overlayText) {
      return <h3 className="card__img-overlay-text">Sample</h3>;
    }
  };

  // Function to display a "Newest" ribbon if applicable
  const showNewest = () => {
    if (newest) {
      return (
        <div className="ribbon">
          <span>Newest</span>
        </div>
      );
    }
  };

  // Function to display a "Not for sale" ribbon if the NFT is not for sale and the user is the owner
  const showNotForSale = () => {
    if (!card.forSale && isOwner !== undefined) {
      return (
        <div
          className="ribbon"
          style={{ backgroundColor: data.web_main_color }}
        >
          <span>Not for sale</span>
        </div>
      );
    }
  };

  // Main component structure with top box for image and bottom box for details
  return (
    <div
      className="nft_card"
      data-token={card?.tokenId}
      data-siteindex={card?.siteTokenIndex}
    >
      <div className="card__top-box">
        {/* NFT Image */}
        <img className={imgClass} src={card.image} alt="NFT"></img>
        {showOverlayText()} {/* Overlay text */}
        {showNewest()} {/* "Newest" ribbon */}
        {showNotForSale()} {/* "Not for sale" ribbon */}
        {/* Download Button */}
        <div
          className="card__download-btn"
          style={download_btn_style}
          onClick={() => onShare(card)}
        >
          <img
            className="card__download-icon"
            src={share_icon}
            alt="download"
          />
        </div>
        {/* Delete Button */}
        <div
          className="card__download-btn"
          style={delete_btn_style}
          onClick={onDelete}
        >
          <div className="card__download-icon">
            <FontAwesomeIcon
              icon={faTrash}
              style={{ height: "1.8rem", color: "#505050" }}
            />
          </div>
        </div>
      </div>

      {/* Bottom Box containing NFT details */}
      <div className="card__bottom-box">
        <div className="card__body">
          {/* Pie Chart showing distribution */}
          <div className="pie__wrapper" onClick={onPieOpen}>
            <PieChart
              className="card-pie"
              data={card.pieData}
              startAngle={-90}
              labelPosition={87}
              radius={40}
            />
          </div>

          {/* Card title and address */}
          <div className="card__body-top">
            <h3 className="card__title" style={{ color: data.web_main_color }}>
              {card.name === null ? "NFT" : card.name}
            </h3>
            <div className="group1">
              <div className="card__text card__addr">{address}</div>
              <h4 className="card__text card__type">{card.distPresetName}</h4>
            </div>
          </div>

          {/* Bottom section with button and price */}
          <div className="card__body-bottom">
            {showButton()} {/* Show button or "MY NFT" label */}
            <h3 className="card__text nft-price">{campaign?.campaign_id ? `${card.price} AVAX` : ""}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MintCard); // Export MintCard and memoize to prevent unnecessary re-renders
